// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .el-input__inner:focus {\n  border-color: #cd0101;\n}\n.el-input__prefix-inner,.el-input__suffix-inner {\n  pointer-events: all;\n  display: inline-flex;\n  align-items: center;\n} */\n", ""]);
// Exports
module.exports = exports;
